module.exports = __webpack_public_path__ + "static/media/junko.ca611830.png";